import { ArrowUp, ArrowDown, Minus } from "lucide-react";
import { ResponsiveContainer, AreaChart, Area } from "recharts";
import { fmtPct } from "@/lib/format";

export default function KpiCard({
  label,
  value,
  change,
  sub,
  testid,
  icon: Icon,
  color = "#A87552",
  sparkline = [],
  sparkKey = "value",
  loading = false,
}) {
  const positive = typeof change === "number" && change > 0;
  const negative = typeof change === "number" && change < 0;
  const hasSparkData = sparkline.some((point) => Number(point?.[sparkKey]) !== 0);
  return (
    <div
      data-testid={testid}
      className="bg-white rounded-3xl border border-black/[0.04] shadow-[0_1px_3px_rgba(0,0,0,0.02)] px-5 pt-5 pb-3 card-hover relative overflow-hidden flex flex-col min-w-0"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2.5 min-w-0">
          {Icon && (
            <span
              className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0"
              style={{ background: `${color}15`, color }}
            >
              <Icon className="w-4 h-4" strokeWidth={2.2} />
            </span>
          )}
          <div className="text-[11px] uppercase tracking-[0.12em] text-[#8E8E93] font-medium truncate">{label}</div>
        </div>
        {!loading && change === null && (
          <div className="text-[10.5px] font-medium text-[#8E8E93] flex-shrink-0">No prior data</div>
        )}
        {!loading && typeof change === "number" && (
          <div className={`inline-flex items-center gap-0.5 text-[11.5px] font-semibold flex-shrink-0 ${positive ? "text-[#0F7B34]" : negative ? "text-[#B01C1C]" : "text-[#8E8E93]"}`}>
            {positive ? <ArrowUp className="w-3 h-3" strokeWidth={2.5} /> : negative ? <ArrowDown className="w-3 h-3" strokeWidth={2.5} /> : <Minus className="w-3 h-3" strokeWidth={2.5} />}
            {fmtPct(change)?.replace("+", "").replace("-", "")}
          </div>
        )}
      </div>
      <div className="mt-4 font-display font-semibold text-[24px] sm:text-[30px] tracking-[-0.028em] text-[#1C1C1E] leading-none break-words">
        {loading ? <span className="inline-block h-7 w-24 rounded-lg bg-black/[0.06] animate-pulse" /> : value}
      </div>
      {sub && <div className="mt-1.5 text-[11.5px] text-[#8E8E93] truncate">{sub}</div>}

      {/* Sparkline */}
      <div className="chart-container h-10 -mx-5 -mb-3 mt-3">
        {!loading && hasSparkData && (
          <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 240, height: 40 }}>
            <AreaChart data={sparkline} margin={{ top: 4, right: 0, bottom: 0, left: 0 }}>
              <defs>
                <linearGradient id={`spark-${testid}`} x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor={color} stopOpacity={0.22} />
                  <stop offset="100%" stopColor={color} stopOpacity={0} />
                </linearGradient>
              </defs>
              <Area
                type="monotone"
                dataKey={sparkKey}
                stroke={color}
                strokeWidth={1.75}
                fill={`url(#spark-${testid})`}
                dot={false}
                isAnimationActive={false}
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}
